var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGecko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5110_2439)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5110_2439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V60H60V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5110_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0757 0.000298929C13.6251 0.0755619 0.350496 13.5665 0.423148 30.1349C0.497876 46.7032 13.8949 60.0729 30.3433 59.9997C46.7939 59.9244 60.0685 46.4335 59.9958 29.8673C59.9212 13.2968 46.5262 -0.0728737 30.0757 0.000298929ZM26.3039 28.5293C23.3625 28.5293 20.9775 26.1292 20.9775 23.1667C20.9775 20.2043 23.3625 17.8042 26.3039 17.8042C29.2453 17.8042 31.6283 20.2064 31.6283 23.1667C31.6283 26.1271 29.2432 28.5293 26.3039 28.5293ZM30.551 34.3266L30.578 34.2931L30.607 34.2597C32.1265 35.2465 33.8618 35.5956 35.5951 35.6458C37.3305 35.6917 39.099 35.5601 40.8385 35.2067C42.5759 34.843 44.2843 34.3057 45.9345 33.6199C46.8603 33.2352 47.782 32.8151 48.66 32.3217C48.6662 32.3175 48.6704 32.3154 48.6767 32.3112C49.2226 31.9809 49.756 31.6318 50.2792 31.2722C50.3933 31.1906 50.5033 31.1049 50.6113 31.0171L50.6237 31.0317L50.6694 31.0861C49.3305 32.3133 47.7363 33.2248 46.1131 34.0297C44.4732 34.8074 42.7628 35.4451 40.9963 35.905C39.236 36.3629 37.399 36.7099 35.539 36.5385C33.7082 36.3754 31.7798 35.7294 30.5468 34.3287L30.551 34.3266ZM44.2179 28.5293C44.2158 27.8853 44.7306 27.3668 45.3658 27.3606C46.0052 27.3585 46.52 27.8749 46.5262 28.5167C46.5282 29.1585 46.0135 29.6833 45.3783 29.6854C44.741 29.6874 44.2241 29.169 44.2179 28.5293ZM35.0948 57.3027C33.9448 49.1848 40.9838 41.2341 44.9527 37.1657C45.8536 36.2437 47.2465 34.9726 48.5417 33.6221C53.6938 28.7697 54.7192 22.9723 44.1743 20.0747C42.1753 19.4914 40.1037 18.6656 38.0051 17.8314C37.9387 17.637 37.8639 17.453 37.7767 17.2795C37.536 16.8614 37.1146 16.3805 36.4773 15.8348C35.1073 14.6369 32.5313 14.6682 30.3081 15.1993C27.8504 14.616 25.4258 14.409 23.0948 14.9714C12.8965 17.8021 11.2567 22.8113 10.8602 28.847C10.3205 35.3698 10.005 40.2306 7.55347 45.7833C4.49377 41.3386 2.68991 35.9468 2.665 30.1286C2.5965 14.8083 14.8726 2.33346 30.0839 2.26447C45.2952 2.19548 57.6813 14.5596 57.7498 29.8798C57.8122 43.5631 48.0228 54.9801 35.0928 57.3069L35.0948 57.3027Z",
    fill: "url(#paint0_linear_5110_2439)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0481 23.2149C30.0481 25.2992 28.3709 26.9864 26.3035 26.9864C24.236 26.9864 22.5566 25.2992 22.5566 23.2149C22.5566 21.1305 24.2339 19.4434 26.3035 19.4434C28.373 19.4434 30.0481 21.1305 30.0481 23.2149Z",
    fill: "#FBC81B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5110_2439",
    x1: 13.4545,
    y1: -0.00000223867,
    x2: 52.6394,
    y2: 25.4082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5110_2439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGecko);
export default __webpack_public_path__ + "static/media/gecko.f8dda855b93c6a58d4e933e0a0afc78f.svg";
export { ForwardRef as ReactComponent };